/**
 * Configuração do Laravel Echo para Vite
 * Substitui o broadcast.js do Laravel Mix
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { NCH_ENV } from '../../js/nch-env';

window.Pusher = Pusher;

// Habilitar logs do Pusher para debug
// Pusher.logToConsole = true;

// Garantir que axios existe
window.axios = window.axios || {};

// broadcast channel nochalks
window.Echo = new Echo({
    authEndpoint: `${window.location.origin}/broadcasting/auth`,
    broadcaster: 'pusher',
    key: NCH_ENV.PUSHER_APP_KEY,
    wsHost: NCH_ENV.PUSHER_HOST,
    wsPort: NCH_ENV.PUSHER_PORT,
    cluster: NCH_ENV.PUSHER_APP_CLUSTER,
    forceTLS: NCH_ENV.PUSHER_SCHEME === 'https',
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    namespace: NCH_ENV.APP_HOST,
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
    },
});

// // Log para debug
// console.log('Echo configurado com:', {
//     key: NCH_ENV.PUSHER_APP_KEY,
//     wsHost: NCH_ENV.PUSHER_HOST,
//     wsPort: NCH_ENV.PUSHER_PORT,
//     wsPath: '/app'
// });

export default { Echo };
